import { render } from "./NewPasswordView.vue?vue&type=template&id=0b7f5073&scoped=true&ts=true"
import script from "./NewPasswordView.vue?vue&type=script&lang=ts"
export * from "./NewPasswordView.vue?vue&type=script&lang=ts"

import "./NewPasswordView.vue?vue&type=style&index=0&id=0b7f5073&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7f5073"]])

export default __exports__